import { Component, computed, effect, inject, input, linkedSignal, model, signal } from '@angular/core';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Business, BusinessBranch, BusinessLicense, createEmptyLicense, toWithFormattedAddress, WithFormattedAddress } from 'src/model/business';
import { BusinessStore } from 'src/model/business/business-store';

@Component({
    selector: 'app-select-business-license',
    templateUrl: './select-business-license.component.html',
    styleUrl: './select-business-license.component.scss',
    standalone: false
})
export class SelectBusinessLicenseComponent {
  private sharedService = inject(SharedService);
  private store = inject(BusinessStore);

  businessList = linkedSignal(() => this.customBusinessList() ?? this.store.businessList());
  businessNameMap = this.store.businessNameMap;
  branchList = this.store.branchList;
  branchMap = this.store.branchMap;
  branchNameMap = this.store.branchNameMap;
  activeLicenseByBranch = this.store.activeLicenseByBranch;

  customLabel = input<string>('Business');
  customBusinessList = input<Business[] | undefined>(undefined);
  businessOnly = input<boolean>(false);
  displayBranchOnly = input<boolean>(true);
  // showBranchWithActiveLicenseOnly = input<boolean>(true);
  disableNoLicenseBranch = input<boolean>(true);
  lockSelection = input<boolean>(false);
  lockBranch = input<boolean>(false);
  compactStyle = input<boolean>(false);

  businessId = model<number>();
  branchId = model<number>();
  // selectedBranch = model<WithFormattedAddress<BusinessBranch>>();

  search = signal<string>('');

  filteredBusinessList = computed(() => {
    const s = this.search().toLowerCase();
    return this.businessList().filter(b => b.Name.toLowerCase().includes(s));
  });
  businessLicenseList = computed<Record<number, WithFormattedAddress<BusinessLicense>[]>>(() => {
    const branches = (this.displayBranchOnly() && this.branchId() ? this.branchList().filter(b => b.Id === this.branchId()) : this.branchList());
    const licenses = branches.flatMap(b => this.activeLicenseByBranch().get(b.Id)?.slice(0, 1) ?? [{ ...createEmptyLicense(), ContactNo: b.ContactNo, Email: b.Email, Address: b.Address, BusinessId: b.BusinessId, BranchId: b.Id }]); // get first active license only
    const businessLicense = licenses.map(l => ({
      ...l,
      BusinessName: this.businessNameMap().get(l.BusinessId),
      BranchName: this.branchNameMap().get(l.BranchId)
    }));
    return this.sharedService.groupByNumKey(businessLicense.map(toWithFormattedAddress), 'BusinessId');
  });
  branchByBusiness = computed<Map<number, WithFormattedAddress<BusinessBranch>[]>>(() => this.sharedService.groupByNumKeyAsMap(this.branchList().map(toWithFormattedAddress), 'BusinessId'));

  constructor() {
    effect(() => {
      const branchId = this.branchId();
      if (this.disableNoLicenseBranch() && this.activeLicenseByBranch().get(branchId) === undefined)
        this.branchId.set(undefined);
    })
  }

  selectBranch(event: Event, id: number) {
    const checked = (event.target as HTMLInputElement).checked;
    this.branchId.set(checked ? id : undefined);
  }

  displayBusinessName = (id: number): string => {
    return this.businessNameMap()?.get(id) ?? '';
  }

  validateSelection(value: string) {
    if (!value || value !== this.businessNameMap().get(this.businessId()))
      this.businessId.set(null);
  }

  filterOptions(value: string) {
    this.search.set(value);
  }

  onOptionSelected(value: number) {
    this.businessId.set(value);
    const branches = this.branchByBusiness().get(this.businessId());
    this.branchId.set(branches?.length > 0 ? branches[0].Id : undefined);
  }
}
